import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import { Link, useLocation, useParams } from "react-router-dom";
import logo from "../../../assets/logos/text-logo-white.svg";
import { ROUTES } from "../../../routes";
import styles from "./Header.module.scss";
import NotificationDropdown from "./NotificationDropdown/NotificationDropdown";
import ProfileDropdown from "./ProfileDropdown/ProfileDropdown";
import Toggler from "./Toggler/Toggler";
import { useDispatch, useSelector } from "react-redux";
import { SearchIcon } from "../../../assets/icons/svgicons";
import Cart from "./Cart/Cart";
import { getCartListAction } from "../../../features/marketPlace/marketPlaceSlice";
import { saveCartCount } from "../../../features/persist/persistSlice";
import {
  getUserAllNotificationAction,
  getnotificationReadStatusAction,
} from "../../../features/user/userSlice";

const Header = ({ handleShow, show }) => {
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const userData = useSelector((state) => state?.persist?.userInfo);
  const cartCount = useSelector((state) => state?.persist?.cartCount);
  const [showCart, setShowCart] = useState(false);
  const isKycApproved = userData?.kyc_status === "APPROVED";
  const [hasUnreadNotifications, setHasUnreadNotifications] = useState(false);

  const getCartItems = async () => {
    try {
      const response = await dispatch(getCartListAction());
      if (response.status === 200) {
        dispatch(saveCartCount(response?.data?.data?.items?.length));
      }
    } catch (error) { }
  };
  const handleNotificationList = async () => {
    try {
      const response = await dispatch(getUserAllNotificationAction());
      if (response.status === 200) {
        // handleReadNotificationList();
      }
    } catch (error) {
      console.log("Failed to fetch notifications", error);
    }
  };

  const handleReadNotificationList = async () => {
    try {
      const response = await dispatch(getnotificationReadStatusAction());
      if (response.status === 200) {
        setHasUnreadNotifications(response.data.data.read_status);
      }
    } catch (error) {
      console.log("Failed to fetch notifications", error);
    }
  };

  useEffect(() => {
    getCartItems();
    handleReadNotificationList();
  }, []);
  const Navabar_heading = (pathname) => {
    switch (pathname) {
      case "/auth/marketplace":
        return {
          heading: "Digital Metals Marketplace",
          subHeading: "Trade precious metal-backed tokens with confidence",
        };

      case "/auth/wallet-portfolio":
        return {
          heading: "My Wallet",
          subHeading: "Manage your fiat and crypto balances",
        };

      case "auth/transactions/opened":
        return {
          heading: "Transactions History",
          subHeading: "Track all your STBL platform activities",
        };
      case "/auth/transactions/opened":
        return {
          heading: "Transactions History",
          subHeading: "Track all your STBL platform activities",
        };
      case "/auth/report":
        return {
          heading: "Reports",
          subHeading:
            "Keep track and manage all your investments from your dashboard",
        };
      case "/auth/settings/my-profile":
        return {
          heading: "Settings",
          subHeading: "Manage your account preferences and security settings",
        };
      case "/auth/report-detail":
        return {
          heading: "Reports",
          subHeading:
            "Keep track and manage all your investments from your dashboard",
        };
      default:
        return {
          heading: `Welcome, ${userData?.first_name || ""}`,
          subHeading: "Here's your portfolio overview for today",
        };
    }
  };

  return (
    <header className={styles.header}>
      <Container>
        <div className={styles.header_inner}>
          <div className={styles.welcome_text}>
            <h3>{Navabar_heading(pathname)?.heading}</h3>
            <p>{Navabar_heading(pathname)?.subHeading}</p>
          </div>
          <Link to={ROUTES.BUY} className={`${styles.logo} d-md-none`}>
            <img src={logo} alt="logo" />
          </Link>
          <div className={styles.header_action}>
            <button
              // onClick={() => {
              //   setShowCart(true);
              // }}
              // className={`${styles.cart_btn} ${cartCount > 0 ? styles.active : ""}`}
              className={styles.search_btn}
              disabled={!isKycApproved}
            >
              {/* <SearchIcon /> */}
            </button>
            <NotificationDropdown
              className={styles.notification}
              disabled={!isKycApproved}
              onClick={handleNotificationList}
              hasUnreadNotifications={hasUnreadNotifications}
              setHasUnreadNotifications={setHasUnreadNotifications}
              handleReadNotificationList={handleReadNotificationList}
            />
            <ProfileDropdown className={styles.profile_dropdown} />
            <Toggler className={styles.toggler} onClick={handleShow} />
          </div>
        </div>
      </Container>
      <Cart show={showCart} handleClose={() => setShowCart(false)} />
    </header>
  );
};

export default Header;
